import { useEffect } from 'react';

export function useDocumentTitle(title: string, description?: string) {
  useEffect(() => {
    document.title = title ? `${title}, Localcontact` : 'Localcontact';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (description) {
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      } else {
        const tag = document.createElement('meta');
        tag.name = 'description';
        tag.content = description;
        document.head.appendChild(tag);
      }
    }
  }, [title, description]);
}
